import { FILTERS, SortDirection } from '../../models/global';

export const actionTypes = {
  GET_ORGANIZATION_SURVEY: 'GET_ORGANIZATION_SURVEY',
  CREATE_ORGANIZATION_SURVEY: 'CREATE_ORGANIZATION_SURVEY',
  LOCK_SURVEY: 'LOCK_SURVEY',
  SUBMIT_SURVEY: 'SUBMIT_SURVEY',
  GET_ORGANIZATION_SURVEYS: 'GET_ORGANIZATION_SURVEYS',
  GET_ORGANIZATION_SURVEYS_SUCCESS: 'GET_ORGANIZATION_SURVEYS_SUCCESS',
  RESET_ORGANIZATION_SURVEYS: 'RESET_ORGANIZATION_SURVEYS',
};

export const getOrganizationSurvey = (data, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_ORGANIZATION_SURVEY,
  callback,
  payload: data,
});

export const createOrganizationSurveyAnswers = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_ORGANIZATION_SURVEY,
  callback,
  payload: data,
});

export const handleSurveyLock = (data, callback = (_res: { isLockedBy: string }, _message: string) => {}) => ({
  type: actionTypes.LOCK_SURVEY,
  callback,
  payload: data,
});

export const submitSurvey = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.SUBMIT_SURVEY,
  callback,
  payload: data,
});

export const getOrganizationSurveys = (
  data: {
    limit: number;
    page: number;
    orderData: {
      orderBy: string;
      sortDirection: SortDirection;
    };
    filters: FILTERS[];
  },
  callback = (_res: boolean, _message: string) => {},
) => ({
  type: actionTypes.GET_ORGANIZATION_SURVEYS,
  payload: data,
  callback,
});

export const getOrganizationSurveysSuccess = data => ({
  type: actionTypes.GET_ORGANIZATION_SURVEYS_SUCCESS,
  payload: data,
});

export const resetOrganizationSurveys = () => ({
  type: actionTypes.RESET_ORGANIZATION_SURVEYS,
});
